export const covertColorToStyle = function(color) {
    return {
        titleBar: {
            backgroundColor: color
        },
        receiverBubble: {},
        senderBubble: {
            backgroundColor: color
        },
        sendButton: {
            backgroundColor: color
        },
        button: {
            backgroundColor: color
        },
        bubbleArrow: {
            fill: color
        }
    };
};

export const covertBgToStyle = function(bg) {
    return {
        chatList: {
            pc: {
                backgroundImage: bg.pc ? `url(${bg.pc})` : ''
            },
            mobile: {
                backgroundImage: bg.mobile ? `url(${bg.mobile})` : ''
            }
        }
    };
};
